import React from "react";
import { Typography } from "@mui/material";
import "./personinfosection.scss";

const EditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
      fill="currentColor"
    />
  </svg>
);

const PersonInfoSection = ({
  personName,
  gender,
  age,
  room,
  sensorId,
  onEditSensor,
  onSensorClick,
}) => {
  return (
    <div className="person-info-section">
      <Typography className="person-name">{personName}</Typography>
      <Typography className="person-details">
        {gender} | {age} {room ? `| ${room}` : ""}
        {sensorId && (
          <>
            {" "}
            | {sensorId}
            {onEditSensor && (
              <button
                className="edit-sensor-btn"
                onClick={onEditSensor}
                aria-label="Edit sensor ID"
              >
                <EditIcon />
              </button>
            )}
          </>
        )}
      </Typography>
      {onSensorClick && (
        <Typography className="sensor-link" onClick={onSensorClick}>
          &gt; Room & Sensor Details
        </Typography>
      )}
    </div>
  );
};

export default PersonInfoSection;
